import { Box } from "@mui/material";

/**
 * Red strip naming a non-production environment, shown on every screen including
 * sign-in. Driven by REACT_APP_ENV_LABEL, which is set per build in
 * .env.development / .env.testing / .env.staging and left empty for production.
 */
export function EnvBanner() {
  const label = (process.env.REACT_APP_ENV_LABEL ?? "").trim();
  if (!label) return null;

  return (
    <Box
      role="note"
      aria-label="Environment"
      sx={(theme) => ({
        backgroundColor: theme.palette.env,
        color: theme.palette.common.white,
        textAlign: "center",
        fontSize: "0.6875rem",
        fontWeight: 500,
        letterSpacing: "0.14em",
        lineHeight: 1.45,
        textTransform: "uppercase",
        py: "3px",
        px: 2,
      })}
    >
      {label}
    </Box>
  );
}

export default EnvBanner;
